import { useEffect, useState } from "react";
import { GetAllTransactionsUseCase } from "../../../domain/usecase/transaction/getAll/UseCase";
import { useSnackbar } from "notistack";
import { Transaction } from "../../../domain/model/Transaction";
import { State } from "../../../domain/model/ResponseState";

export function TransactionsViewModel(
  getAllTransactionsUseCase: GetAllTransactionsUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState<
    Array<Transaction> | undefined
  >([]);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false);

  const [skip, setSkip] = useState(0);
  const limit = 40;

  useEffect(() => {
    getTransactions();
  }, []);

  async function getTransactions() {
    setLoading(true);
    const response = await getAllTransactionsUseCase.invoke(skip, limit);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        if (response.data.length < limit) setShowLoadMoreButton(false);
        else setShowLoadMoreButton(true);
        setTransactions(transactions?.concat(response.data));
        setSkip(skip + limit);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return { transactions, isLoading, showLoadMoreButton, getTransactions };
}
